import React from 'react';

import ProfileLayout from 'components/ProfileLayout';
import UserElementsListContainer from 'containers/UserElementsListContainer';
import { inject, observer } from 'mobx-react';
import { ElementType } from 'models/ApiElementTypeEnum';
import { ApplicationStoreType } from 'models/ApplicationStore';
import { DataStoreType } from 'models/DataStore';
import { HistoryProps, idFromMatch } from 'utils/history';

interface UserHypothesesListScreenProps {
  dataStore: DataStoreType;
  applicationStore: ApplicationStoreType;
}

@inject('dataStore', 'applicationStore')
@observer
class UserHypothesesListScreen extends React.Component<
  HistoryProps & UserHypothesesListScreenProps
> {
  render() {
    const { match, dataStore, applicationStore } = this.props;
    const userId = idFromMatch(match);
    const user = dataStore.users.get(userId!.toString())!;
    const isSelf = applicationStore.currentUser?.id === userId;

    return (
      <ProfileLayout
        active="hypotheses"
        userName={user!.full_name}
        userId={user!.id}
        isSelf={isSelf}
      >
        <UserElementsListContainer
          elementType={ElementType.Hypothesis}
          user={user}
        />
      </ProfileLayout>
    );
  }
}

export default (props: any) => {
  // @ts-ignore
  return <UserHypothesesListScreen {...props} />;
};
